// 手機版置底選單
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import { useParams } from 'next/navigation';
import { MOBILE_MENU } from '@/common/constant';
import Link from 'next/link';
import Image from 'next/image';
import { setShowComingModal, setShowLoginModal } from '@/slices/popSlice';
import useScrollDirection from '@/hook/useScrollDirection';
import useIsIphonePWA from '@/hook/useCheckIphone';

const Button = ({ v, title }) => {
    return (
        <>
            <Image
                width={30}
                height={30}
                src={`/images/icon/icon_${v?.toLowerCase()}.svg`}
                alt="icon"
            />
            <span>{title}</span>
        </>
    );
};

const MobileBottomMenu = ({ t, dispatch, setShowUserModal, uid }) => {
    const params = useParams();
    const { newsSlug } = params;
    const { web1Url } = useSelector(urlState);
    const scrollDirection = useScrollDirection();
    const isIphonePWA = useIsIphonePWA();

    return (
        <div
            className={`menu hidden fixed bottom-0 w-screen left-0 z-[10] ulg:block pt-[4px] pb-[3px] px-[15px] bg-[rgba(0,0,0,.7)] backdrop-blur-[10px] trans
            ${newsSlug ? '' : 'ulg:!bottom-0'} ${
                scrollDirection !== 'down' ? 'ulg:bottom-0' : 'ulg:bottom-[-70px]'
            } ${isIphonePWA ? '!pb-[12px]' : 'h-[58px]'}`}
        >
            <div className="between-center mx-auto max-w-[342px] text-bd3n text-black1 [&>*]:text-center">
                {MOBILE_MENU.map((v, i) => {
                    // 我的
                    if (v === 'MINE' || v === 'FORUM' || v === 'SHOP')
                        return (
                            <button
                                key={'mobile' + v + i}
                                onClick={() => {
                                    if (v === 'MINE') {
                                        if (!uid) dispatch(setShowLoginModal(true));
                                        else dispatch(setShowUserModal(true));
                                    } else dispatch(setShowComingModal(v));
                                }}
                            >
                                <Button v={v} title={t(v)} />
                            </button>
                        );

                    // 色澀
                    if (v === 'PORN')
                        return (
                            <Link key={'mobile' + v + i} href="/">
                                <Button v={v} title={t(v)} />
                            </Link>
                        );

                    // 一站
                    return (
                        <a
                            key={'mobile' + v + i}
                            target="_blank"
                            rel="noreferrer noopener"
                            href={web1Url}
                        >
                            <Button v={v} title={t(v)} />
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileBottomMenu;
